import React from 'react'
import TabLinkUI from "../../../../widgets/output/TabLinkUI"
import './MasterTemplateNav.css'

const MasterLoanAgrGuaranteeNavUI = ({ context, page }) =>
  <div className='g_flex_h g_flex_wrap g_flex_left g_p_left_100 master-template-nav-tertiary g_m_top_25'>
    <TabLinkUI label='Pledge Terms' to='/su/master/loanAgreement/pledge' active={page === 'pledge'} />
    <TabLinkUI label='NDU Terms' to='/su/master/loanAgreement/ndu' active={page === 'ndu'} />
  </div>

export default MasterLoanAgrGuaranteeNavUI
